import { Instagram, Phone, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { ContactForm } from "@/components/site/ContactForm";
import { CONTACT } from "@/data/site";

export const ContactBlock = ({ defaultService = "", title = "Pedir orçamento" }) => (
  <section id="orcamento" data-testid="contact-block" className="border-t border-white/10">
    <div className="mx-auto grid max-w-[1440px] gap-16 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Contacto</Eyebrow>
        <h2 className="mt-5 font-display text-5xl font-semibold uppercase leading-[0.85] tracking-tight sm:text-7xl">{title}</h2>
        <p className="mt-6 max-w-sm text-white/75">Conte-nos um pouco sobre o seu cão. Respondemos com um orçamento à medida, sem compromisso.</p>
        <div className="mt-10 space-y-4">
          <a href={CONTACT.phoneHref} data-testid="contact-block-phone" className="flex items-center gap-3 text-lg font-semibold hover:text-[#C8D484]"><Phone className="h-5 w-5 text-[#C8D484]" />{CONTACT.phone}</a>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="contact-block-instagram" className="flex items-center gap-3 hover:text-[#C8D484]"><Instagram className="h-5 w-5 text-[#C8D484]" />{CONTACT.instagramHandle}</a>
          <a href={CONTACT.instagramBanhos} target="_blank" rel="noreferrer" data-testid="contact-block-instagram-banhos" className="flex items-center gap-3 hover:text-[#C8D484]"><Instagram className="h-5 w-5 text-[#C8D484]" />{CONTACT.instagramBanhosHandle}<span className="hidden text-sm text-white/60 sm:inline">· Banhos & Tosquias</span></a>
          <a href={CONTACT.mapLink} target="_blank" rel="noreferrer" data-testid="contact-block-address" className="flex items-center gap-3 hover:text-[#C8D484]"><MapPin className="h-5 w-5 text-[#C8D484]" />{CONTACT.address}</a>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-7">
        <ContactForm defaultService={defaultService} />
      </Reveal>
    </div>
  </section>
);
